import React, { memo, useEffect, useRef } from 'react';
const TokboxVideo = ({ videoElement, mirrored }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (mirrored) {
            videoElement.style.transform = 'scaleX(-1)';
        }
        videoElement.style.width = '100%';
        videoElement.setAttribute('disablePictureInPicture', 'true');
        videoElement.setAttribute('playsInline', 'true');
        ref.current?.append(videoElement);
    }, [mirrored, videoElement]);
    return React.createElement("div", { ref: ref });
};
export default memo(TokboxVideo);
//# sourceMappingURL=tokboxVideo.js.map